import ProductCode from "./ProductCode"

export default ProductCode
